import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import Header from '../../components/common/header/Header';
import Footer from "../../components/common/Footer";
import LoadingOverlay from 'react-loading-overlay';
import { Redirect, useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { groupBy, forEach, remove, concat, findIndex } from 'lodash';
import { syncUserCartAction, setUserReqProdsListAction } from '../../modules/su/userCartModule';
import { reqEsItemListAction, reqEsItemListIngAction} from '../../modules/es/esItemModule';
import {isMobileOnly, isIOS} from 'react-device-detect';
import {Waypoint} from 'react-waypoint'; //for scroll spy
import {Toast, toast, ToastLeft} from '../../components/common/noti/Toast'
import { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import Modal from 'react-modal';
import $ from 'jquery';
import NormalInput from '../../components/common/input/NormalInput';
import MyEsReqFormList from '../../components/es/MyEsReqFormList'

import MyEsSrMyCartDvry from '../../components/es/MyEsSrMyCartDvry';
import CheckBtn from '../../components/common/button/CheckBtn';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import NormalPopupOneBtn from '../../components/common/popup/NormalPopupOneBtn';
import { EnCryptData } from '../../lib/util/CustomUtil';
import { EsApplyInfoDao, setEsApplyDelAllAction, reqEsApplyMultiAction } from '../../modules/es/esApplyModule';
import { setEsMyInit } from '../../modules/es/esMyModule'
import * as CONSTANTS from '../../lib/util/Constants';
import { getCateListAction } from '../../modules/common/cateModule';

/**
 * 수납함
 */
const RequestFormBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        //padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};
    
    .ea_num {font-weight:700;}
    .info-concurrency-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:${isMobileOnly? '12px': '14px'};
      position:relative;
      margin-top: ${isMobileOnly? '6px': '12px'};
    }

    #siteMoveBtn {
        bottom: ${isMobileOnly? '110px': '10px'};
        ${isMobileOnly?`
        width: 48px;
        height: 48px;
        background: url(/assets/images/icon/sitemove-icon-mobile.png) center center/cover
        no-repeat;
        border-radius: 10px;
        z-index: 1;
        background-size: 72px 72px;
        margin-right: 2vw;
      `:`
        width: 96px;
        height: 96px;
        
      `};
      }

      .yellow {
        color: #ffc742;
    }
`;

const RequestFormHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0;
         
    `:`
        
    `};
    height:${props => props.height2};
    padding-bottom: ${props => props.bottom};
    position:relative;
`;

const EstimateStepHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 0 32px 0;
         
    `:`
        
        margin-bottom: 20px;
    `};
    position:relative;

    .title-num {
        //width: 100vw;
        height: 50px;
        color: #cccccc;
        font-family: 'Berkshire Swash';
        font-size: 18px;
        line-height: 1.28;
        padding-top: 8px;

        .num-left {
            margin-right: 8px;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 4px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/arrow_my_title.svg) center center/auto no-repeat;
                vertical-align: 6px;
            }
        }
        .num-right {
            margin-left: 8px;
        }
    }

    .close {
        margin-top: 6px;
        margin-right: -3vw;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
    }
    
    .title {
        ${isMobileOnly?`
        font-size: 22px;
        line-height: 1.45;
        `:`
        font-size: 24px;
        line-height: 1.5;
        `};
        font-family: NotoSansKR;
        
        font-weight: bold;
        
        color: #111111;
    }

    .sub {
        font-size: 12px;
        font-weight: normal;
        font-family: NotoSansKR;
        line-height: 2.17;
        color: #cccccc;
    }
`;

const RequestFormHeaderTitleMBlock = styled.div`
    width: 100vw;
      
    height: 50px;
    margin: 0 0 20px;
    //padding: 7px 125px 7px 2px;
    background-color: #ffffff;
    position: relative;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #111111;
    line-height: 50px;
    margin-left: -4vw;
`;

const RequestFormHeaderTitleMBtnBlock = styled.button`
    width: 36px;
    height: 36px;
    position: absolute;
    top: 7px;
    left: 2px;
    background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
`;

const RequestFormHeaderTitleBlock =styled.div`
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: center;
    color: #111111;
`;

const RequestFormHeaderGrayLine = styled.div`
${isMobileOnly?`
    width: 100vw;
    margin-left: -4vw;
    `:`
    width: 718px;
    margin-left: -40px;
    `};
    height: 8px;
    
    
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;

const RequestFormContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    
`;

const RequestFormBottomBlock = styled.div`
    ${isMobileOnly?`
    width: 100vw;
    margin-left: -4vw;
    `:`
    width: 718px;
    margin-left: -40px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    `};

    font-weight: normal;
    color: #333333;
    padding: 79px 0 60px;
    background-color: #f4f4f4;
    text-align: center;
`;

const RequestFomBottomTxt1Block = styled.div`
    ${isMobileOnly?`
        margin: 0;
        font-size: 16px;
        height: 28px;
        line-height: 1.19;
    `:`
    height: 42px;
    font-size: 18px;
    height: 28px;
    line-height: 28px;
    `};
    margin-bottom: 10px;
    font-weight: 500;
`;

const RequestFomBottomTxt2Block = styled.div`
    font-size: 14px;
    line-height: 1.57;
    margin-bottom: 30px;
`;

const RequestFomBottomTxt3Block = styled.div`
    ${isMobileOnly?`
    font-size: 13px;
    margin-bottom: 10px;
    `:`
    font-size: 16px;
    margin-bottom: 10px;
    `};

    
    width: 100%;
    line-height: 26px;
`;

const RequestFomBottomTxt4Block = styled.div`
    ${isMobileOnly?`
    font-size: 12px;
    `:`
    font-size: 14px;
    `};
    
    color: #999999;
`;

const RequestFormRequestContainerBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    margin-left: -4vw;
    `:`
    height : 100px;
    width: 100%;
    margin: 0 auto;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
    background-color: #f4f4f4;
`;

const RequestFormRequestBlock = styled.div`
    ${isMobileOnly?`
    height : 103px;
    width: 100vw;
    left: 0;
    //border-top-left-radius: 10px;
    //border-top-right-radius: 10px;
    border-top: solid 1px #999999;
    background-color: #ffffff;
    `:`
    height : 100px;
    width: 100vw;
    //min-width: 100%;
    right: 0;
    border-top-left-radius: 20px;
    //min-width : 771px;
    left: 0px;
    `};
    display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    //background-color: #ffc742;
    z-index:9;
    
    &.nofixed {
        position:relative;
        //float: right;
        button { font-weight: 600;}
        left: 0px;
  }
  &.bottom {
    border-top: none;
    animation: mymove 2s;
    background-color: rgba(255,255,255,0);
  }

  @keyframes mymove {
    from {background-color: rgba(255,255,255,1);}
    to {background-color: rgba(255,255,255,0);}
  }
`;

const RequestFormRequestContentsBlock = styled.div`
    ${isMobileOnly?`
    height : 103px;
    width: 100vw;
    //margin-left: -4vw;
    `:`
    height : 100px;
    //width: 1176px;
    width: 100vw;
    margin: 0 auto;
    max-width: 1236px;
    //margin-top: 40px;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;

const RequestFormRequestTotalBlcok = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 33vw;
    line-height: 70px;
    font-size: 14px;
    font-weight: 500;
    `:`
    height : 100px;
    //width: 230px;
    line-height: 100px;
    font-size: 20px;
    font-weight: 600;
    margin-left: 30px;
    `};
    float: left;
    color: #111111;
    text-align: center;
`;

const RequestFormRequestBtnBlock = styled.button`
    ${isMobileOnly?`
    height : 70px;
    width : 66vw;
    text-align: center;
    float: left;
    `:`
    height : 100px;
    //width : 540px;
    text-align: right;
    padding-right: 30px;
    float: right;
    `};
    
    
    color: #111111;
    
`;

const RequestFormRequestSpanBlock = styled.span`
    ${isMobileOnly?`
    line-height: 70px;
    font-size: 16px;
    `:`
    line-height: 100px;
    font-size: 20px;
    `};
    position: relative;
    
    font-weight: 500;
    color: #111111;
    &:after {
        content: '';
        display: block;
        position: absolute;
        width: 0%;
        left: 0;
        top: 24px;
        height: 1px;
        background-color: #111111;
        z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }

    &.line::after {
        width: 100%;
    }

`;

const RequestFormRequestLineBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 27px;
    `:`
    margin-top: 42px;
    `};
    width: 0;
    height: 16px;
    border-left: solid 1px #111111;
    float: left;
`;

const EstimateStepBottomBlock = styled.div`
    //margin: 0 -4vw; 
    width: 100vw;
    //display: block;
    //position:fixed;
    bottom:0;
    z-index: 10;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    //border-top: solid 1px #999999;
    padding: 20px 10px 30px;
    display: ${props => props.display || 'none'};
    //background-color: #ffffff;

    .list {
        padding: 0 18px 0 16px;
    }
    .title {
        color: #999999;
        //margin: 0 18px 0 16px;
        width: 96px;
        display: inline-block;
    }
    .desc {
        color: #333333;
    }

    .num {
        font-weight: 600;
    }

    .green {
        //margin: 0 18px 0 16px;
        color: #79b88a;
    }

    .pre {
        border-radius: 4px;
        background-color: #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
    }

    .next {
        border-radius: 4px;
        background-color: #ffc742;
        text-align: center;
        color: #111111;
        height: 52px;
        width: 79%;
        float: right;

        .num {
            //color: #ffc742;
            font-weight: 600;
        }
    }
`;

const EstimateStepContentsPCBlock = styled.div`
    width: 1176px;
    margin: 0 auto;
    margin-top: 80px;
    position: relative;
    min-height: 707px;

    .left_con {
        width: 720px;
        //height: 707px;
        float: left;
        position: relative;
        padding: 40px 40px 0px 40px;
        border-radius: 10px;
        border: solid 1px #666666;
        margin-left: 40px;
        ::after {
            content: '';
            display: inline-block;
            width: 48px;
            height: 50px;
            background: url(/assets/images/icon/clip.png) center center/auto no-repeat;
            position: absolute;
            background-size: 48px 50px;
            top: -27px;
            right: 33px;
        }
    }

    .right_con {
        width: 355px;
        float: left;
        margin-left: 20px;
        position: relative;
        height: 707px;

        .title {
            font-size: 18px;
            font-weight: 500;
            line-height: 2;
            color: #333333;
            margin-bottom: 15px;
            line-height: 1.2;
        }

        .step {
            font-size: 20px;
            font-weight: 500;
            color: #ffc742;
            line-height: 1.2;

            .five {
                font-weight: normal;
                color: #999999;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #cccccc;
        }

        .sub_title {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #999999;
            padding-left: 20px;
        }

        .sub_content {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            margin-top: 8px;
            padding: 0 20px;
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
        }
        .next {
            border-radius: 4px;
            background-color: #ffc742;
            text-align: center;
            color: #111111;
            height: 52px;
            width: 100%;
            
            .num {
                font-weight: bold;
            }

            .limit {
                font-size: 14px;
            }
            
        }
        .pre {
            border-radius: 4px;
            //background-color: #ececec;
            text-align: center;
            color: #333333;
            height: 52px;
            width: 100%;
            float: left;
            border: solid 1px #cccccc;
            background-color: #ffffff;
        }

        .line_dot {
            width: 100%;
            height: 1px;
            border-bottom: dotted 1px #cccccc;
        }

        .total {
            float: left;
            padding-left: 20px;
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 26px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/my_estimate.svg) center center/auto no-repeat;
                vertical-align: -6px;
            }
        }

        .total_price {
            font-size: 20px;
            font-weight: 600;
            text-align: right;
            color: #fc1c67;

            .won {
                font-size: 18px;
                font-weight: normal;
                color: #111111;
            }
        }
        
    }
`;

const EstimateStepBlankBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    height: ${props => props.height};//130px;  103px;
`;

const MAX_CNT = CONSTANTS.MAX_RQST_CNT;
const MAX_PROD = CONSTANTS.MAX_PROD;
const IOS_OFFSET_TOP = 100;
const EstimateStep5 = () => {

    const dispatch = useDispatch();
    const [availCnt, setAvailCnt] = useState(MAX_CNT);
    const [prodNum, setProdNum] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const refBlockReq = useRef(null);
    const history = useHistory();
    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);
    const [over, setOver] = useState(false);
    const [pckgNm, setPckgNm] = useState("");
    const pckgNmRef = useRef(null);
    const [deleteData, setDeleteData] = useState({brnd_id:0, prdct_id:0, opt_id:0});
    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState("");
    const [kind, setKind] = useState(0);
    const [countProd, setCountProd] = useState(0);
    const [inputRef, setInputRef] = useState([]);
    const [date, setDate] = useState();
    const [postNum, setPostNum] = useState("");
    const [addr, setAddr] = useState("");
    const [addr2, setAddr2] = useState("");
    const [area, setArea] = useState(0);
    const [place, setPlace] = useState(0);
    const [areaType, setAreaType] = useState(1);
    const [question, setQuestion] = useState([]);
    const [priceConfirm, setPriceConfirm] = useState(1); // 설치 비용
    const addrRef = useRef(null);
    const [lastConfirm, setLastConfirm] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [request, setRequest] = useState(false);
    const deliverRef = useRef(null);
    const refRightCon = useRef(null);
    const refLeftCon = useRef(null);
    const refBottom = useRef(null);
    const [fixWing, setFixWing] = useState(true);
    const [cateItems, setCateItems] = useState([]); 

    const [fakeInput, setFakeInput] = useState(null);
    const [focus, setFocus] = useState(false);
    const [viewport, setViewport] = useState ({
        "maxHeight": window!==undefined&&window.visualViewport!==undefined?window.visualViewport.height:"100vh",
        "maxWidth": "100vw"
        })

    const { accessToken, esItems, esItemsCheck, reqProdList, esApplyResult, id , cartProdList, loading, esMyBudget, categoryItems 
        ,esMyBrandCate3Step, esSelBrandStep3} = useSelector(
        ({ userReducer, userCartReducer, esItemsReducer, esApplyReducer, loadingReducer, esMyReducer, cateItemsReducer }) => ({
            accessToken: userReducer.accessToken,
            esItems: esItemsReducer.esItems,
            esIemsCheck: esItemsReducer.esIemsCheck,
            reqProdList: userCartReducer.reqProdList,
            esApplyResult: esApplyReducer.esApplyResult,
            id: userReducer.id,
            cartProdList: userCartReducer.cartProdList,
            loading: loadingReducer['esapply/REQ_TYPE_POST_ESAPPLY_MULTI'],
            esMyBudget: esMyReducer.esMyBudget,
            categoryItems: cateItemsReducer.cateItems,
            esMyBrandCate3Step: esMyReducer.esMyBrandCate3Step,
            esSelBrandStep3: esMyReducer.esSelBrandStep3,
        })
    );

    useEffect(() => {
        //console.log("---reqProdList = " + JSON.stringify(reqProdList));
        if(reqProdList !== null && reqProdList !== undefined  && reqProdList.length > 0) {
            //console.log("--------1111-------")
            let price = 0;
            let prdNum = 0;
            let count = 0;

            forEach(reqProdList, (item, index) => {
                if( item !== null && item !== undefined && item.list !== null){
                    forEach(item.list, (curobj, index) => {
                        price += curobj.es_opt_pirce*1*curobj.qty*1;
                        prdNum += curobj.qty*1;
                        count = count + curobj.qty*1;
                    });
                }
            });
            setTotalPrice(price);
            setProdNum(prdNum);
            setCountProd(count);
            
        } else {
            setTotalPrice(0);
            setProdNum(0);
        }

    },[reqProdList])

    useEffect(() => {
        if(reqProdList !== null && reqProdList !== undefined  && reqProdList.length > 0) {
            
            
        } else {
            history.goBack();
        }

    },[])

    //#2611 top 버튼 처리
    useEffect(() => {

        var $moveBtn = $('#siteMoveBtn');
        if($moveBtn.length){
            $moveBtn.fadeOut();
        }

        // scroll 이벤트를 만들어줍니다. 스크롤을 움직일때 마다
        // onScroll 함수가 실행됩니다.
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if(!isMobileOnly) {
            window.addEventListener("resize", onScroll);
        }
        
        return () => {
            if(!isMobileOnly) {
                window.removeEventListener("resize", onScroll)};
            }
    }, []);

    useEffect(() => {
        if(accessToken !== null){
            if(request){
                //dispatch(reqEsItemListAction()); // 견적정보 get
                dispatch(reqEsItemListIngAction());
            } else {
                onCloseModalLogin();
                //dispatch(reqEsItemListAction()); // 견적정보 get
                dispatch(reqEsItemListIngAction());
            }
        }
    },[accessToken])

    useEffect(() => {
        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
            try {
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                }
            } catch (e) { }

            if(request){
                onCloseModalLogin();
                if(cnt > 0){
                    handleRequest(cnt);
                }else{
                    let message = "나의 견적 횟수를 모두 사용했어요 😭\n견적서를 정리할 수 있도록 견적체크 페이지로 이동합니다."
                    setKind(2);
                    setMsg(message);
                    setOpenModal(true);
                }
            }
        }

    }, [esItems])

    useEffect(() => {
        // console.log('aT',accessToken)
        if (esApplyResult !== null && esApplyResult.code === 200) {
            setShowToast(true);
            //dispatch(setEsApplyDelAllAction());

            /* let msg = " 견적 요청이 완료되었습니다.\n가구견적으로 이동합니다.";
            toast('SUCCESS', msg);
            //dispatch(setEsMyInit());

            setTimeout(() => {
                //history.replace('/es');
                history.replace("/es",{ index: 0 })
            }, 2000); */

            let message = "수고하셨습니다!\n견적 요청이 완료되었습니다.\n끄-적으로 더 알아볼까요?"
            setKind(5);
            setMsg(message);
            setOpenModal(true);
            
            if (accessToken !== null) {
                forEach(reqProdList, (item, index) => {
                    if( item !== null && item !== undefined && item.list !== null && item.list.length > 0){
                        
                        forEach(item.list, (curobj, index) => {
                            remove(cartProdList, (obj) => {
                                return (obj.prdct_id === curobj.prdct_id && obj.opt_id === curobj.opt_id);
                            })
                        });
                    }
                })
                
                dispatch(syncUserCartAction(cartProdList));
            }

            let brandList = [];
            dispatch(setUserReqProdsListAction(brandList));

            //주소 localstorage 저장하기
             if(accessToken !== null){
                let address = {};
                address.zipcode = postNum;
                address.addr1 = addr;
                address.addr2 = addr2;
                address.id = id;

                localStorage.setItem('address', EnCryptData(JSON.stringify(address)));
            }

            dispatch(setEsApplyDelAllAction());
        }
    }, [esApplyResult])

    const onScroll = () => {
        var nowScroll = $(window).scrollTop();
        var $priceBtn = $('#priceBtn');

        var nowScroll = $(window).scrollTop();

            var $moveBtn = $('#siteMoveBtn');
            if($moveBtn.length){
                if ( nowScroll < 350 ) {
                    $moveBtn.fadeOut();
                } else {
                    $moveBtn.fadeIn();
                }
            }

        /* if($priceBtn.length) {
            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                //$priceBtn.fadeOut();
                setPriceView(false)
            } else {
                //$priceBtn.fadeIn();
                setPriceView(true)
            }
        } */

        if(!isMobileOnly&&refRightCon && refRightCon.current) {

            if (refBottom.current) {
                if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < refBottom.current.offsetTop - 720) {
                    setFixWing(true);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        const wing = refRightCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset = " + offset);
                        $(wing).css('left', offset + 720);
    
                    }
                }
                else {
                    setFixWing(false);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset22 = " + offset);

                        const wing = refRightCon.current;
                        $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);
    
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (refBottom.current) {
            if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < (refBottom.current.offsetTop )) {
                setFixWing(true);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    const wing = refRightCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset = " + offset);
                    $(wing).css('left', offset + 720);

                }
            }
            else {
                setFixWing(false);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset22 = " + offset);

                    const wing = refRightCon.current;
                    $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);

                }
            }
        }

    }, [refRightCon.current, refLeftCon.current, refBottom.current]);

    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {
            let arr = [];
            let first = false;
            forEach(categoryItems, (curobj, index) => {
                let cate1Id = curobj.id;
                forEach(curobj.cate2, (cate2, index) => {
                    let cateid = cate1Id*100 + cate2.id*1;
                    let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                    arr.push(cateItem);
                });
            });
            
            if(esMyBrandCate3Step && esMyBrandCate3Step.length > 0) {
                forEach(arr, (cate, index) => {
                    let idx = findIndex(esMyBrandCate3Step, (curitem) => {
                        //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                        return curitem*1 === cate.id*1;
                    })
    
                    if(idx >= 0) {
                        cate.on = true;

                    } else {
                        cate.on = false;
                    }
                });
    
                //console.log("arr22 = " + JSON.stringify(arr));
                setCateItems(arr);

            } 
            
        }

    }, [categoryItems]);

    /* useEffect(() => {
        const onScroll = () => {
          if(!isMobileOnly) {
              $('.fixed').css({left: 0 - $(window).scrollLeft()});
              $('.nofixed').css({left: 0 });
          }
        };
      
        if(!isMobileOnly) {
            $('.fixed').css({left: 0 - $(window).scrollLeft()});
            $('.nofixed').css({left: 0 });
        }
        
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
      }, []); */
    

    const updateViewport = () => {
        if(viewport.maxHeight*1 - 150 > window.visualViewport.height) {
            handleFocus();
        } else {
            handleBlur();
        }
    /* setViewport ({
        "maxHeight": window.visualViewport.height,
        "maxWidth": window.visualViewport.width
    }) */

    
    }

    useEffect (() => {
        if (isMobileOnly && typeof window !== "undefined" && typeof window.visualViewport !== "undefined") {
            setViewport ({
                "maxHeight": window.visualViewport.height,
                "maxWidth": window.visualViewport.width
            })

            updateViewport ()

            window.visualViewport.addEventListener ("resize", updateViewport)

            return () =>
            window.visualViewport.removeEventListener ("resize", updateViewport)
        }
    }, [])

    useEffect(() => {
        if (isMobileOnly&&refBlockReq.current) {
            refBlockReq.current.classList.remove('nofixed');
            refBlockReq.current.classList.add('fixed');
        }

    }, [refBlockReq]);

      
    const  handleFocus = ()=> {
        if(isMobileOnly) {
            setFocus(true);
            if(refBlockReq&&refBlockReq.current) {
                refBlockReq.current.classList.remove('fixed');
                refBlockReq.current.classList.add('nofixed');
                var $moveBtn = $('#siteMoveBtn');
                if($moveBtn.length){
                    $moveBtn.css({position:'absolute'});
                }
            }
        }
    } 

    const  handleBlur = ()=> {
        if(isMobileOnly) {
            setFocus(false);
            if(refBlockReq&&refBlockReq.current) {
                refBlockReq.current.classList.remove('nofixed');
                refBlockReq.current.classList.add('fixed');
                var $moveBtn = $('#siteMoveBtn');
                if($moveBtn.length){
                    $moveBtn.css({position:'fixed'});
                }
            }
        }
    } 

     //#2611 top 버튼 처리
     const handleTopClick = () => {
        //window.scrollTo({ top: 200, behavior: 'smooth' });
        $('html, body').stop().animate({
            scrollTop: 0
        }, 500, 'swing');
    }

    const handlerBrandChangeQty = (brnd_id, prdct_id, opt_id, value) => {
        let brandList = [];
        Object.assign(brandList, reqProdList);

        let idx = findIndex(brandList, (curItem) => {
            return curItem.brnd_id === brnd_id
        })

        if (idx !== -1) {
            let prodList = {};
            Object.assign(prodList,brandList[idx]);
            
            let index = findIndex(prodList.list, (curItem) => {
                return curItem.prdct_id === prdct_id && curItem.opt_id === opt_id
            })

            if(index >= 0) {
                let list = {};
                Object.assign(list, prodList.list[index]);
                list.es_prdct_price = (list.es_opt_pirce * 1) * (value*1);
                list.qty = value;
                prodList.list[index] = list;
                brandList[idx] = prodList;

                dispatch(setUserReqProdsListAction(brandList));
            }
        }

    }


    const handlerBrandListItemDelete = (brnd_id, prdct_id, opt_id) => {

        setDeleteData({brnd_id:brnd_id, prdct_id:prdct_id, opt_id:opt_id});

        let count = 0;

        let idx = findIndex(reqProdList, (curItem) => {
            return curItem.brnd_id === brnd_id
        })

        if(idx >= 0) {
            let index = findIndex(reqProdList[idx].list, (curItem) => {
                return curItem.prdct_id === prdct_id && curItem.opt_id === opt_id
            })

            if(index >= 0) {
                let list = reqProdList[idx].list[index];
                count = list.qty;
            }

        }
        //console.log("reqProdList = " + JSON.stringify(reqProdList))
        //console.log("count = " + JSON.stringify(count))
 
        if(reqProdList !== undefined && reqProdList !== null) {
            if(countProd - count < CONSTANTS.MIN_ITEM) {
                let msg=`전체 상품 ${CONSTANTS.MIN_ITEM}개 이상일 경우 견적이 진행됩니다.\n선택한 상품을 삭제 시 견적 알아보기 페이지가 닫힙니다.`
                setMsg(msg);
                setKind(1);
            } else {
                let msg="선택한 상품을 삭제합니다."
                setMsg(msg);
                setKind(0);
            }
            setOpenModal(true);
        }
    }

    const handlerInputRef = (input) => {
        if(inputRef !== null && inputRef.length > 0) {
            remove(inputRef.list, (curItem) => {
                return curItem.brnd_id === input.brnd_id
            })
        }
        
        inputRef.push(input);
    }

    const handlerPrice = (brnd_id, price ) => {
        let brandList = [];
        Object.assign(brandList, reqProdList);

        let idx = findIndex(brandList, (curItem) => {
            return curItem.brnd_id === brnd_id
        })

        //console.log('price = ' + price)
        if (idx !== -1) {
            let prodList = {};
            Object.assign(prodList,brandList[idx]);
            prodList.price = price;
            brandList[idx] = prodList;
            dispatch(setUserReqProdsListAction(brandList));
        }
    }

    const deleteProdctItem = () =>{
        if(deleteData !== null && deleteData.brnd_id !== null && deleteData.brnd_id*1 > 0) {
            let brnd_id = deleteData.brnd_id;
            let prdct_id = deleteData.prdct_id;
            let opt_id = deleteData.opt_id;

            let brandList = [];
            Object.assign(brandList, reqProdList);
    
            let idx = findIndex(brandList, (curItem) => {
                return curItem.brnd_id === brnd_id
            })
    
            if (idx !== -1) {
                let prodList = {};
                Object.assign(prodList,brandList[idx]);

                remove(prodList.list, (curItem) => {
                    return curItem.prdct_id === prdct_id && curItem.opt_id === opt_id
                })
    

                if(prodList.list.length === 0) {
                    remove(brandList, (curItem) => {
                        return curItem.brnd_id === brnd_id
                    })
                } else {
                    brandList[idx] = prodList;
                }

                //brandList[idx] = prodList;
    

                dispatch(setUserReqProdsListAction(brandList));
            }
        }

        setOpenModal(false);
    }

    const deleteProdctItemAndBack = () => {
        deleteProdctItem();
        handleBack();
    }

    const deleteAndClose = () => {
        setOpenModal(false);
        handleBack();
    }

    const delectAndMoveEs = () => {
        setOpenModal(false);
        let brandList = [];
        dispatch(setUserReqProdsListAction(brandList));
        //history.replace('/es');
        history.replace("/es",{ index: 0})
    }

    const handleOneBtnPopupClick = () => {
        setOpenModal(false);
        $('html, body').animate({
            scrollTop: 200
        }, 500, 'swing', function(){});
    }

    const getPopup = () => {
        if (kind === 0) {
            return (<NormalPopup
                text={""}
                text2={msg}
                text3={""}
                btn1="삭제" btn2="취소"
                onClick1={deleteProdctItem}
                onClick2={handleModalBtn2Click} />)
        } else if (kind === 1) {
            return (<NormalPopup
                text={""}
                text2={msg}
                text3={""}
                btn1="삭제" btn2="취소"
                onClick1={deleteProdctItemAndBack}
                onClick2={handleModalBtn2Click} />)
        } else if (kind === 2) {
            return (<NormalPopupOneBtn
                text=""
                text2={msg} text3=""
                btn="확인" onClick={delectAndMoveEs} />)

            /* return (<NormalPopup
                text={""}
                text2={msg}
                text3={""}
                btn1="닫기" btn2="이동"
                onClick1={deleteAndClose}
                onClick2={delectAndMoveEs} />) */
        } else if (kind === 3) {
            return (<NormalPopupOneBtn
                text=""
                text2={msg} text3=""
                btn="확인" onClick={handleOneBtnPopupClick} />)
        } else if (kind === 4) {
            
            return (<NormalPopup
                text={""}
                text2={msg}
                text3={""}
                btn1="뒤로가기" btn2="취소"
                onClick1={handleBack}
                onClick2={handleModalBtn2Click} />)
        } else if (kind === 5) {
            return (<NormalPopup
                text={""}
                text2={msg}
                text3={""}
                centerBtn={true}
                btn1="네, 알아볼래요" btn2="아니오, 다음에 할래요"
                onClick1={handleGotoMyEs}
                onClick2={handleGotoEs} />)
        }
    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    const handleModalBtn2Click = () => {
        //dispatch(reqEsItemListAction());
        setOpenModal(false);

        if(kind === 5) {
            handleGotoEs();
        }
    }

    const onOpenModalLogin = () => {
        setOpenModalLogin(true);
    }

    const onCloseModalLogin = () => {
        setOpenModalLogin(false);
        setFromLoginPU(false);
    }

    const fakeInputDo = () => {
        return;
        /* if(isIOS&&isMobileOnly) {

            if(fakeInput) {
                    fakeInput.focus();
                return fakeInput;
            }
            
            const _fakeInput = document.createElement('input');
            _fakeInput.setAttribute('type', 'text');
            _fakeInput.setAttribute('readonly', 'true');
            _fakeInput.style.position = 'absolute';
            _fakeInput.style.opacity = 0;
            _fakeInput.style.height = 0;
            _fakeInput.style.fontSize = '16px'; // disable auto zoom
            
            // you may need to append to another element depending on the browser's auto 
            // zoom/scroll behavior
            document.body.prepend(_fakeInput);
            
            // focus so that subsequent async focus will work
            _fakeInput.focus();
            setFakeInput(_fakeInput);
            
            return _fakeInput;
        } */
    }

    const checkValid = (count) => {
        let msg="";

        if (pckgNm === null || pckgNm.length === 0) {
            msg = "나의 견적서 이름을 입력해 주세요.";
            toast('SUCCESS', msg);
            if(pckgNmRef&&pckgNmRef.current){
                fakeInputDo();
                if(isMobileOnly) {
                    setTimeout(() => {
                        if(isIOS) {
                            //window.scrollTo(0,0,{ behavior: 'smooth' });
                            $('html, body').stop().animate({
                                scrollTop: 0
                            }, 250, 'swing');
                        } else {
                            pckgNmRef.current.focus();
                        }
                    }, 2000); 
                } else {
                    pckgNmRef.current.focus();
                }
            }
            return false;
        }
        
        if(inputRef !== null && inputRef.length > 0) {
            for(let i = 0 ; i < inputRef.length; i++) {
                if(inputRef[i].inputRef !== null && inputRef[i].inputRef.current !== null) {

                    const value = inputRef[i].inputRef.current.value;
                    if(value !== null) {
                        if(value.length === 0 || value*1 === 0) {
                            msg = "희망견적금액을 입력해 주세요.";
                            toast('SUCCESS', msg);
                            fakeInputDo();
                            if(isMobileOnly) {
                                setTimeout(() => {
                                    if(isIOS) {
                                        //window.scrollTo({ top: inputRef[i].inputRef.current.offsetTop - IOS_OFFSET_TOP, behavior: 'smooth' });
                                        $('html, body').stop().animate({
                                            scrollTop: inputRef[i].inputRef.current.offsetTop - IOS_OFFSET_TOP
                                        }, 250, 'swing');
                                    } else {
                                        inputRef[i].inputRef.current.focus();
                                    }
                                }, 2000); 
                            } else {
                                inputRef[i].inputRef.current.focus();
                            }
                            
                            //inputRef[i].inputRef.current.focus();
                            return false;
                        }
                    } else {
                        
                        msg = "희망견적금액을 입력해 주세요.";
                        toast('SUCCESS', msg);
                        fakeInputDo();
                        if(isMobileOnly) {
                            setTimeout(() => {
                                if(isIOS) {
                                    //window.scrollTo({ top: inputRef[i].inputRef.current.offsetTop - IOS_OFFSET_TOP, behavior: 'smooth' });
                                    $('html, body').stop().animate({
                                        scrollTop: inputRef[i].inputRef.current.offsetTop - IOS_OFFSET_TOP
                                    }, 250, 'swing');
                                } else {
                                    inputRef[i].inputRef.current.focus();
                                }
                            }, 2000); 
                        } else {
                            inputRef[i].inputRef.current.focus();
                        }
                        
                        //inputRef[i].inputRef.current.focus();
                        return false;
                    }

                }
            }
        }

        if (addr === null || addr === "") {
            msg = "배송지역을 입력해 주세요.";
            toast('SUCCESS', msg);
            if(addrRef&&addrRef.current){
                fakeInputDo();
                if(isMobileOnly) {
                    setTimeout(() => {
                        if(isIOS) {
                            if(deliverRef&&deliverRef.current) {
                                //window.scrollTo({ top: deliverRef.current.offsetTop + IOS_OFFSET_TOP, behavior: 'smooth' });
                                $('html, body').stop().animate({
                                    scrollTop: deliverRef.current.offsetTop + IOS_OFFSET_TOP
                                }, 250, 'swing');
                            }
                        } else {
                            addrRef.current.focus();
                        }
                    }, 2000); 
                } else {
                    addrRef.current.focus();
                }
            }
            
            /* if (addrRef.current) {
                addrRef.current.focus();
            }  */
            return false;
        }

        if (addr2 === null || addr2 === "") {
            msg = "배송지역을 입력해 주세요.";
            toast('SUCCESS', msg);
            if(addrRef&&addrRef.current){
                fakeInputDo();
                if(isMobileOnly) {
                    setTimeout(() => {
                        if(isIOS) {
                            if(deliverRef&&deliverRef.current) {
                                //window.scrollTo({ top: deliverRef.current.offsetTop + IOS_OFFSET_TOP, behavior: 'smooth' });
                                $('html, body').stop().animate({
                                    scrollTop: deliverRef.current.offsetTop + IOS_OFFSET_TOP
                                }, 250, 'swing');
                            }
                        } else {
                            addrRef.current.focus();
                        }
                    }, 2000); 
                } else {
                    addrRef.current.focus();
                }
            }
            
            return false;
        }

        if(lastConfirm === false) {
            msg = "마지막 확인 사항을 선택해주세요";
            toast('SUCCESS', msg);
            $('html, body').animate({
                scrollTop: document.body.scrollHeight
            }, 500, 'swing', function(){});
            return false;
        }

        if (count < reqProdList.length) {
            msg = "회원님의 견적 진행 가능한 브랜드 수량은 " +  count + "개입니다.";
            toast('SUCCESS', msg);
            $('html, body').animate({
                scrollTop: 200
            }, 500, 'swing', function(){});
            return false;
        }

        if (prodNum < CONSTANTS.MIN_ITEM) {
            let msg=`전체 상품 수가 ${CONSTANTS.MIN_ITEM}개 이상일 경우 견적을 알아볼 수 있어요`
            setMsg(msg);
            setKind(3);
  
            setOpenModal(true);

            return false;
        }

        return true;
    }

    const handleLastConfirm = () =>{
        setLastConfirm(!lastConfirm);
    }

    const getCurDate = () => {
        let curdate = new Date();
        return curdate.toISOString().slice(0, 10).replace('T', ' ')
    }

    const handleBack = () => {
        //history.goBack();
        setOpenModal(false);
        let brandList = [];
        dispatch(setUserReqProdsListAction(brandList));
        //history.replace('/mycart');
        history.goBack();
    }

    const handleGotoEs = () => {
        dispatch(setEsMyInit());
        setOpenModal(false);
        history.replace("/es",{ index: 0 })
    }

    const handleGotoMyEs = () => {
        dispatch(setEsMyInit());
        setOpenModal(false);
        history.replace("/estimate/step1")
    }

    const handleRequest = (count) => {

        if(showToast){
            return;
        }

        // 견적 요청하고
        if (accessToken !== null) {

            if (checkValid(count)) {

                let reqInfoArray = [];
                let itemArray = [];

                forEach(reqProdList, (item, index) => {
                    if( item !== null && item !== undefined && item.list !== null && item.list.length > 0){
                        let _totalprice = 0;
                        let _totalCnt = 0;
                        forEach(item.list, (curobj, index) => {
                            let tPrice2 = curobj.es_opt_pirce*1*curobj.qty*1;
                            
                            _totalprice += tPrice2;

                            _totalCnt = _totalCnt + curobj.qty*1;
                        });
    
                        let _question = '';
                        //공통 질문
                        let idx = findIndex(question, (curItem) => {
                            return curItem.brnd_id*1 === 1
                        })
                        
                        if(idx >= 0) {
                            let text = question[idx].question;
                            _question = "1. " + _question + text;
                        }
    
                        //브랜드 질문
                        idx = findIndex(question, (curItem) => {
                            return curItem.brnd_id*1 === item.brnd_id*1
                        })
    
                        if(idx >= 0) {
                            let text = question[idx].question;
                            if(_question.length > 0) {
                                _question =  _question + "\n" +  "2. " + text;
                            } else {
                                _question = "1. " + _question + text;
                            }
                            
                        }
    
                        //console.log("_qeustion = " + JSON.stringify(_question))
                        let reqInfo = EsApplyInfoDao();
                        reqInfo.rqst_status = "050102"; // 요청
                        reqInfo.pckg_nm = pckgNm+'_'+(index+1);
                        reqInfo.rqst_price = item.price; // 희망 견적 금액
                        reqInfo.es_prod_total_price = _totalprice;
                        reqInfo.brnd_cd = item.list[0].brnd_cd;
                        reqInfo.es_prod_cnt = _totalCnt;
                        reqInfo.dsrd_date = date;
                        reqInfo.zipcode = postNum;
                        reqInfo.addr1 = addr;
                        reqInfo.addr2 = addr2;
                        reqInfo.area_type = areaType;
                        reqInfo.area_size = area;
                        reqInfo.is_install_chrg = priceConfirm;
                        reqInfo.house_type = place;
                        reqInfo.es_question = _question;

                        reqInfoArray.push(reqInfo);
                        itemArray.push(item.list);
                    }
                });

                if(itemArray.length > 0) {
                    dispatch(setEsApplyDelAllAction());
                    //console.log("reqInfoArray = " + JSON.stringify(reqInfoArray));
                    //console.log("itemArray = " + JSON.stringify(itemArray));
                    dispatch(reqEsApplyMultiAction(accessToken, reqInfoArray, itemArray));
                }
            }


        } else {
            if(checkValid(count)){
                let msg = "어디가구 회원만 견적을 낼 수 있어요\n로그인해주세요";
                toast('SUCCESS', msg);

                setTimeout(() => {
                    setRequest(true);
                    // 로그인 팝업 표시
                    onOpenModalLogin();
                }, 2000);
            }
        }
    }

    const handleMouseEnter = () => {
        setOver(true);
    }

    const handleMouseLeave = () => {
        setOver(false);
    }

    const checkBottomPosition = (props) => {
        //console.log('check = ',JSON.stringify(props))

       if(props.currentPosition === Waypoint.below && refBlockReq.current) {
           //console.log("nofixed remove")
           //refBlockReq.current.classList.remove('nofixed');
            //refBlockReq.current.classList.add('fixed');
            refBlockReq.current.classList.remove('bottom');
            $('#pre_btn').css({"background-color":"#ececec"});
       } 
       else if(props.currentPosition === Waypoint.inside && props.previousPosition === Waypoint.below && refBlockReq.current) {
           //console.log("nofixed add")
           //refBlockReq.current.classList.remove('fixed');
            //refBlockReq.current.classList.add('nofixed');
            refBlockReq.current.classList.add('bottom');
            $('#pre_btn').css({"background-color":"#e0e0e0"});
       }
       //console.log('check = ',JSON.stringify(refBlockReq.current.classList))

   }

    const handlePre = () => {
        /* let msg = "해당 Step에서 입력한 모든 내용이\n초기화 됩니다";
        setKind(4);
        setMsg(msg);
        setOpenModal(true); */
        //history.goBack();
        handleBack();
    }

    const getPrice = () => {
        if(esMyBudget === 0) {
            return "";
        } else {
            return Number(esMyBudget.toFixed(1)).toLocaleString() + "원"
        }

    }

    const getCate2Name = () => {
        let txtCate2 = "";
        cateItems.map((cateitem,index) => {
            const cateid = cateitem.id;
            const name = cateitem.name;
            if(cateitem.on) {
                if(txtCate2.length === 0) {
                    txtCate2 = name + "";
                } else {
                    txtCate2 = txtCate2 + ", "+name;
                }
            }
            
        })

        return txtCate2;
    }

    const getBrandName = () => {
        let txtBrand = "";
        esSelBrandStep3.map((brand,index) => {
            const name = brand.brnd_han;
            if(txtBrand.length === 0) {
                txtBrand = name + "";
            } else {
                txtBrand = txtBrand + ", "+name;
            }
        })

        return txtBrand;
    }

    const getPrductNum = () => {
        let txtNum = "";
        if(prodNum>0){
            txtNum=prodNum + "개";
        }

        return txtNum;
    }

    const setEsBoxPosition = (fixWing) => {
        let style = fixWing ? { position: 'fixed', left: '772px',bottom: 'auto'/* , bottom: 'auto', marginTop: '30px' */ } : { position: 'absolute', left: '772px', bottom: '0px'/* , bottom: '100px', marginTop: '30px' */ }
        return isMobileOnly ? { marginTop: '30px' } : style;
    }

    return (
        isMobileOnly?
        <RequestFormBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
            <RequestFormHeaderBlock>
                <EstimateStepHeaderBlock className="clearfix">
                    <div className="clearfix">
                    <div className="title-num f-left"><span className="num-left yellow">4</span><span>4</span></div>{/* <div className="close f-right"></div> */}
                    </div>
                    <div className="title"><p><span className="yellow">마지막 끄-적!</span></p><p>꼼꼼히 작성해주세요👍</p></div>
                    {/* <div className="sub">나만의 가구 견적 알아보기</div> */}

                </EstimateStepHeaderBlock>
                
                <div className="es_title-box" style={isMobileOnly ? {width: '100%'}:{width: '360px', margin:'12px auto 0'}}>
                    <div className="inputbox">
                        <NormalInput width="100%" maxLength='25'
                            placeholder='나의 견적서 이름을 입력해 주세요.'
                            inputRef={pckgNmRef}
                            textAlign = 'center'
                            onFoucs={handleFocus}
                            onBlur={handleBlur}
                            onChange={(e) => { setPckgNm(e.target.value) }} />
                    </div>
                </div>
            </RequestFormHeaderBlock>
            <RequestFormHeaderGrayLine style={{marginTop:'30px'}}/>
            <RequestFormContentsBlock>
                <MyEsReqFormList handlerBrandChangeQty={handlerBrandChangeQty} handlerDeleteItem={handlerBrandListItemDelete} 
                    handlerInput={handlerInputRef} handlerPrice={handlerPrice} handleFocus={handleFocus} handleBlur={handleBlur}/>
                <RequestFormHeaderGrayLine style={{marginTop:'40px'}}/>
                <div className="default-table margin-b_30" style={isMobileOnly ? { marginTop:'40px'}:{width:'1176px', marginTop:'80px'}}>
                    <h3 className="dt-title" style={isMobileOnly ? {fontSize:'16px', fontWeight:'500', color:'#333333'}:{fontWeight:'500'}} ref={deliverRef}>배송 정보 및 추가 사항</h3>

                    <MyEsSrMyCartDvry
                    postNumHandler={(param) => { setPostNum(param) }}
                    dateHandler={(param) => { setDate(param) }}
                    addrHandler={(param) => { setAddr(param) }}
                    addr2Handler={(param) => { setAddr2(param) }}
                    areaTypeHandler={(param) => { setAreaType(param) }}
                    placeHandler={(param) => { setPlace(param) }}
                    areaHandler={(param) => { setArea(param) }}
                    questionHandler={(param) => { setQuestion(param) }}
                    priceConfirmHandler={(param) => { setPriceConfirm(param) }}
                    handleFocus={handleFocus} handleBlur={handleBlur}
                    reffer={addrRef} 
                    />

                </div>
                
            </RequestFormContentsBlock>
                <RequestFormBottomBlock>
                    <RequestFomBottomTxt1Block>브랜드별로 견적이 이루어집니다.</RequestFomBottomTxt1Block>
                    <RequestFomBottomTxt2Block>견적 알아보기 시 중간 수정이 불가하며<br/>브랜드 판매자가 
                            회원님께 제안한 견적서는<br/><span style={{fontWeight:'500'}}>[견적체크] 메뉴</span>에서 확인 가능합니다.</RequestFomBottomTxt2Block>
                    <RequestFomBottomTxt3Block className="clearfix">
                        <div style={{margin: '0 auto', width:'fit-content', height:'30px'}}>
                            <div  style={{float:'left', height:'30px', marginRight:'7px'}}>
                                <CheckBtn defaultValue={lastConfirm} onClick={handleLastConfirm}/>
                            </div>
                            <div  style={{float:'left', height:'30px', paddingTop:'3px'}}>
                            위 내용을 확인했습니다.(필수)
                            </div>
                            
                        </div>
                        </RequestFomBottomTxt3Block>
                    <RequestFomBottomTxt4Block>견적 요청일 : {getCurDate()}</RequestFomBottomTxt4Block>
                </RequestFormBottomBlock>

            <RequestFormRequestContainerBlock display={ prodNum > 0 ? 'block' : 'none'  }>
                            
            <RequestFormRequestBlock ref={refBlockReq} className="fixed">
                <RequestFormRequestContentsBlock>
                    <EstimateStepBottomBlock display={"block"}>
                    {/* <div className="list margin_b-10"><span className="title">총 예상 금액</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                    <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                    <div className="list margin_b-20"><div className="green">*품목별 수량이 1개일 경우의 예상 범위 금액입니다.</div></div> */}
                    <button id="pre_btn" className="pre" onClick={handlePre}>이전</button>
                    <button className="next" onClick={()=>handleRequest(availCnt)}>
                    <span className="num">{Number((totalPrice * 1).toFixed(1)).toLocaleString()}</span>원 견적 요청하기
                    </button>
                </EstimateStepBottomBlock>
                    {/* <RequestFormRequestTotalBlcok>{Number((totalPrice * 1).toFixed(1)).toLocaleString()}<span style={isMobileOnly? {fontSize:'14px', fontWeight:'normal'}:{fontSize:'18px', fontWeight:'normal'}}>원</span></RequestFormRequestTotalBlcok>
                    {isMobileOnly&&<RequestFormRequestLineBlock/>}
                    <RequestFormRequestBtnBlock onClick={()=>handleRequest(availCnt)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <RequestFormRequestSpanBlock className={over? "line" : ""}><span style={isMobileOnly ? {fontSize:'18px', fontWeight:'bold'}:{fontSize:'22px', fontWeight:'600'}}>{prodNum}</span>개 상품 견적 요청하기</RequestFormRequestSpanBlock>
                    </RequestFormRequestBtnBlock> */}
                </RequestFormRequestContentsBlock>
            </RequestFormRequestBlock>
            </RequestFormRequestContainerBlock>
            
            <Waypoint onPositionChange={(props)=>checkBottomPosition(props)} fireOnRapidScroll></Waypoint>
            <Toast bottom={"30px"}/>
            <div id="siteMoveBtn" style={{display: "none"}}>
                <button type="button" className="top" onClick={handleTopClick}></button>
            </div>
            
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>

            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>
            </LoadingOverlay>
        </RequestFormBlock>
        :
        <RequestFormBlock>
            <LoadingOverlay
                active={loading}
                spinner
                text=''
            >
            <Header />
            <EstimateStepContentsPCBlock className="clearfix">
                <div className="left_con clearfix" ref={refLeftCon}>
                    <RequestFormHeaderBlock>
                        <EstimateStepHeaderBlock className="clearfix">
                            <div className="title"><p><span className="yellow">마지막 끄-적!</span> 꼼꼼히 작성해주세요👍</p></div>
                        </EstimateStepHeaderBlock>
                        <div className="es_title-box" style={{width: '343px'}}>
                            <div className="inputbox">
                                <NormalInput width="100%" maxLength='25'
                                    placeholder='나의 견적서 이름을 입력해 주세요.'
                                    inputRef={pckgNmRef}
                                    textAlign = 'left'
                                    onChange={(e) => { setPckgNm(e.target.value) }} />
                            </div>
                        </div>
                        
                    </RequestFormHeaderBlock>
                    <RequestFormHeaderGrayLine style={{marginTop:'30px'}}/>
                    <RequestFormContentsBlock>
                        <MyEsReqFormList handlerBrandChangeQty={handlerBrandChangeQty} handlerDeleteItem={handlerBrandListItemDelete} 
                            handlerInput={handlerInputRef} handlerPrice={handlerPrice}/>
                        <RequestFormHeaderGrayLine style={{marginTop:'40px'}}/>
                        <div className="default-table margin-b_30" style={isMobileOnly ? { marginTop:'40px'}:{width:'100%', marginTop:'40px'}}>
                            <h3 className="dt-title" style={isMobileOnly ? {fontSize:'16px', fontWeight:'500', color:'#333333'}:{fontWeight:'500'}}>배송 정보 및 추가 사항</h3>

                            <MyEsSrMyCartDvry
                            postNumHandler={(param) => { setPostNum(param) }}
                            dateHandler={(param) => { setDate(param) }}
                            addrHandler={(param) => { setAddr(param) }}
                            addr2Handler={(param) => { setAddr2(param) }}
                            areaTypeHandler={(param) => { setAreaType(param) }}
                            placeHandler={(param) => { setPlace(param) }}
                            areaHandler={(param) => { setArea(param) }}
                            questionHandler={(param) => { setQuestion(param) }}
                            priceConfirmHandler={(param) => { setPriceConfirm(param) }}
                            reffer={addrRef} 
                            />

                        </div>
                        
                    </RequestFormContentsBlock>
                    <RequestFormBottomBlock>
                        <RequestFomBottomTxt1Block>브랜드별로 견적이 이루어집니다.</RequestFomBottomTxt1Block>
                        <RequestFomBottomTxt2Block>견적 알아보기 시 중간 수정이 불가하며<br/>브랜드 판매자가 
                                회원님께 제안한 견적서는 <span style={{fontWeight:'500'}}>[견적체크] 메뉴</span>에서 확인 가능합니다.</RequestFomBottomTxt2Block>
                        <RequestFomBottomTxt3Block className="clearfix">
                            <div style={{margin: '0 auto', width:'fit-content', height:'30px'}}>
                                <div  style={{float:'left', height:'30px', marginRight:'7px'}}>
                                    <CheckBtn defaultValue={lastConfirm} onClick={handleLastConfirm}/>
                                </div>
                                <div  style={{float:'left', height:'30px', paddingTop:'3px'}}>
                                위 내용을 확인했습니다.(필수)
                                </div>
                                
                            </div>
                            </RequestFomBottomTxt3Block>
                        <RequestFomBottomTxt4Block>견적 요청일 : {getCurDate()}</RequestFomBottomTxt4Block>
                    </RequestFormBottomBlock>
                </div>
                <div className="right_con clearfix" ref={refRightCon} style={setEsBoxPosition(fixWing)}>
                        <div className="title">나만의 상품 견적 알아보기</div>
                        <div className="step margin_b-40"><span>Step 4 </span><span className="five">/ 4</span></div>
                        <div className="line margin_b-20" />
                        <div className="sub_title">1. 카테고리</div>
                        <div className="sub_content margin_b-20">{getCate2Name()}</div>
                        <div className="sub_title">2. 예산</div>
                        <div className="sub_content margin_b-20">{getPrice()}</div>
                        {/* <div className="sub_title">3. 브랜드</div>
                        <div className="sub_content margin_b-20">{getBrandName()}</div> */}
                        <div className="sub_title">3. 상품</div>
                        {
                            prodNum>0?
                            <div>
                                <div className="sub_content margin_b-10">{getPrductNum()}</div>
                                <div className="line_dot margin_b-20" />
                                <div>
                                    <div className="total">총계</div>
                                    <div className="total_price "> {totalPrice&&Number(totalPrice.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                                </div>
                                
                            </div>
                            :
                            ''
                        }
                        
                        <div className="line margin_t-20" />
                        <div className="bottom">
                            {/* {
                                prodNum<MIN_CNT?
                                <button className="next margin_b-10" ><span className="num1">{prodNum}</span>개 확인하기<span className="limit"> ({MIN_CNT}개 이상)</span></button>
                                :
                                <button className="next margin_b-10" onClick={handleNext}><span className="num">{prodNum}</span>개 요청서 작성하기 👉</button>
                            } */}
                            <button className="next margin_b-10" onClick={()=>handleRequest(availCnt)}>
                            <span className="num">{Number((totalPrice * 1).toFixed(1)).toLocaleString()}</span>원 견적 요청하기
                            </button>
                            <button className="pre" onClick={handlePre}>이전</button>
                        </div>
                    </div>
            </EstimateStepContentsPCBlock>
            <EstimateStepBlankBlock ref={refBottom} height={"160px"}>&nbsp;</EstimateStepBlankBlock>
            <ToastLeft bottom={"0px"}/>
            <Footer siteMovePosition={isMobileOnly?'80px':'80px'} />
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>

            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>
            </LoadingOverlay>
        </RequestFormBlock>
    );
};

export default EstimateStep5;
